import Avatar from "@xtribe/shared/components/lib/Avatar";
import Button from "@xtribe/shared/components/lib/Button";
import Input from "@xtribe/shared/components/lib/Input";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

const OnboardingStartForm: React.FC = ({}) => {
  const { register, handleSubmit, errors } = useForm();
  const router = useRouter();
  const onSubmit = ({ email, name }: { email: string; name: string }) => {
    console.log(
      `/start-typeform?email=${encodeURIComponent(
        email ?? ""
      )}&name=${encodeURIComponent(name ?? "")}`
    );
    router.push(
      `/start-typeform?email=${encodeURIComponent(
        email ?? ""
      )}&name=${encodeURIComponent(name ?? "")}`
    );
  };
  return (
    <form
      className="max-w-md mx-auto flex flex-col items-center"
      name="start-onboarding-form"
      id="start-onboarding-form"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Avatar.Group>
        <Avatar src={undefined} text="E" storageLink stacked />
        <Avatar src={undefined} text="D" storageLink stacked />
      </Avatar.Group>
      <h5 className="h5 mt-6 text-center">
        Möchtest du xTribe in Action sehen?
      </h5>
      <p className="text-foreground-soft mt-3 text-center">
        Melde dich mit deinem Einladungscode an, nehm an unserem Online
        Onboarding teil und starte dein 14 Tage Probeabo.
      </p>
      <div className="max-w-md w-full mx-auto mt-8">
        <Input
          width="100%"
          size="large"
          name="name"
          ref={register({ required: true })}
        >
          Voller Name
        </Input>
        {errors.name && (
          <p className="text-sm text-red mt-1">
            {errors.name?.message || "Dieses Feld wird benötigt"}
          </p>
        )}
        <div className="h-6" />
        <Input
          width="100%"
          size="large"
          aria-errormessage="ERROR"
          name="email"
          ref={register({
            required: true,
            pattern: {
              message: "Keine gültige Email",
              value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
            },
          })}
        >
          Email
        </Input>
        {errors.email && (
          <p className="text-sm text-red mt-1">
            {errors.email?.message || "Dieses Feld wird benötigt"}
          </p>
        )}
        <div className="h-6" />
        <div className="flex flex-col">
          <Button
            homepageBtn
            htmlType="submit"
            type="success"
            size="large"
            form="start-onboarding-form"
          >
            Kostenlos Starten
          </Button>
        </div>
      </div>
    </form>
  );
};

export default OnboardingStartForm;
